import _ from 'lodash';
import store from '@/store';

declare global {
  interface Event {
    maxTimestampDiff?: number,
    scannerSequence?: string
  }
}

const DEV_MODE = process.env.NODE_ENV !== 'production';
const VERBOSE_LOG = DEV_MODE && false;

class ScannerEventHandler {
  private delay = 20;
  private guard?: number;
  private events: Array<Event> = [];
  private threshold: number = 20; // number of milliseconds
  
  constructor(delay: number = 20) {
    this.delay = delay;
  }

  public handleKeypressInternal(ev: Event) {
    this.events.push(ev);
    if (VERBOSE_LOG) console.log(this.events);
    this.guardCall();
  }
  
  private guardCall() {
    if (this.guard) {
      window.clearTimeout(this.guard);
    }
    this.guard = window.setTimeout(() => {
      if (DEV_MODE) {
        console.log(`ScannerEventHandler: events in buffer`);
        console.log(this.events);
      }
      this.postDelay();
      window.clearTimeout(this.guard);
    }, this.delay);
  }

  private postDelay() {
    if (this.isScannerSequence()) {
      let sequence: string|undefined = this.fetchScannerSequence();
      if (sequence) {
        if (DEV_MODE) console.log(`%cScannerEventHandler: sequence successfully captured (value = "${sequence}")`, "color:green");
        this.emitScanEvent(sequence);
      }
    }
    this.events = [];
  }

  private isScannerSequence() {
    let first: Event|undefined = _.first(this.events);
    if (!(first instanceof KeyboardEvent)) {
      if (DEV_MODE) console.log('ScannerEventHandler: not a keyboard event');
      return false;
    }
    if (this.events.length < 2) {
      if (DEV_MODE) console.log('ScannerEventHandler: too short sequence');
      return false;
    }
    if (this.events.length != 14) {
      if (DEV_MODE) console.log('ScannerEventHandler: sequence not equal 13');
      return false;
    }
    let targetNodeName = _.toLower(_.get(first, 'target.nodeName'));
    if (targetNodeName !== 'body') {
      if (DEV_MODE) console.log(`ScannerEventHandler: not dispatched to body (target node is "${targetNodeName}")`);
      return false;
    }
    let maxScannerInputEvent = this.events.reduce((previousEvent, currentEvent) => {
      let prevDiff = _.get(previousEvent, 'maxTimestampDiff', 0),
          prevTS = _.get(previousEvent, 'timeStamp', 0),
          currentTS = _.get(currentEvent, 'timeStamp', 0),
          diff = Math.abs(prevTS - currentTS);
      if (diff > prevDiff) {
        currentEvent.maxTimestampDiff = diff;
      } else {
        currentEvent.maxTimestampDiff = prevDiff;
      }
      return currentEvent;
    });
    if (typeof maxScannerInputEvent.maxTimestampDiff === 'undefined') {
      if (DEV_MODE) console.warn(`ScannerEventHandler: undefined timestampDiff (!!) (${maxScannerInputEvent}ms)`);
      return false;
    }
    if (maxScannerInputEvent.maxTimestampDiff > this.threshold) {
      if (DEV_MODE) console.log(`ScannerEventHandler: too big input intervals (${maxScannerInputEvent}ms)`);
      return false;
    }
    let last: Event|undefined = _.last(this.events);
    if (_.get(last, 'keyCode') != 13) {
      if (DEV_MODE) console.log(`ScannerEventHandler: sequence not trailed with "Enter" key (${maxScannerInputEvent}ms)`);
      return false;
    }
    return true;
  }

  private fetchScannerSequence(): string|undefined {
    this.events.pop();
    this.events = [new Event('keydown')].concat(this.events);
    let reduced = this.events.reduce((previousEvent, currentEvent) => {
      let seq = _.get(previousEvent, 'scannerSequence', ''),
          currentKey = _.get(currentEvent, 'key', '');
      currentEvent.scannerSequence = `${seq}${currentKey}`;
      return currentEvent;
    });
    return reduced.scannerSequence;
  }

  private emitScanEvent(value: string) {
    store.dispatch('scannerInput', value);
  }
}

const handler = new ScannerEventHandler();

class ScannerManual {

  constructor() {
    
  }

  start() {
    document.addEventListener('keydown', this.handleKeypress);
  }

  stop() {
    document.removeEventListener('keydown', this.handleKeypress);
  }

  public handleKeypress(ev: Event) {
    handler.handleKeypressInternal(ev);
  }

}

const scanner = new ScannerManual();

export default scanner; 